export enum EstadoEnum {
  AC = 'AC',
  PE = 'PE',
  RE = 'RE',
  IN = 'IN',
  OK = 'OK',
}

export enum MotivoEnum {
  PENDIENTE_COMPLETAR = 3,
  PENDIENTE_DE_REVISION_Y_VALIDACION_POR_PARTE_DE_LA_AFP = 38,
  PENDIENTE_GENERAR_NOTIFICACION_DE_PAGO = 127,
  PENDIENTE_DE_VALIDAR_METODO_DE_PAGO = 115,
  PENDIENTE_DE_VALIDAR_POR_ENTIDAD_RECAUDADORA = 121,
}
